var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9640_44800",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "url(#pattern0_9640_44800)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9640_44800)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "url(#pattern1_9640_44800)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#01924F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_9640_44800",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_9640_44800",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_9640_44800",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_9640_44800",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_9640_44800",
    width: 50,
    height: 50,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.158288f6d53f1e23b109c9fa81cc1918.svg";
export { ForwardRef as ReactComponent };